import { render, staticRenderFns } from "./ExpirationNotifications.vue?vue&type=template&id=5d655a5c&scoped=true&"
import script from "./ExpirationNotifications.vue?vue&type=script&lang=js&"
export * from "./ExpirationNotifications.vue?vue&type=script&lang=js&"
import style0 from "./ExpirationNotifications.vue?vue&type=style&index=0&id=5d655a5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d655a5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
